import { render, staticRenderFns } from "./ProductCategorySelect.vue?vue&type=template&id=2764237a&scoped=true&"
import script from "./ProductCategorySelect.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategorySelect.vue?vue&type=style&index=0&id=2764237a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764237a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VSlideGroup,VSlideItem})
